export default function (el) {
    let attrs = {};
    for(let key in el.dataset) {
        if (~key.indexOf('attr') && !key.indexOf('attr')) {
            let attrKey = key.replace('attr', '');
            attrKey = attrKey.charAt(0).toLowerCase() + attrKey.slice(1);
            if (attrKey) {
                attrs[attrKey] = el.dataset[key];
            }
        }
    }
    return attrs;
}